import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createBlock(_component_v_overlay, {
    class: "align-center justify-center",
    "model-value": _ctx.showWarning,
    persistent: "",
    scrim: "#000000",
    "z-index": 2400
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "pa-6 text-center",
        "max-width": "460",
        elevation: "8"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-h6 mb-2" }, "Are you still there?", -1)),
          _createElementVNode("div", _hoisted_1, "You'll be signed out due to inactivity in " + _toDisplayString(_ctx.secondsLeft) + " second" + _toDisplayString(_ctx.secondsLeft === 1 ? '' : 's') + ".", 1),
          _createVNode(_component_v_btn, {
            color: "primary",
            onClick: $options.markActivity
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Stay signed in", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}